
import { Link, useNavigate } from "react-router-dom";

export default function DashboardCard({
  icon: Icon,
  label,
  count,
  to,
  bgColor = "bg-white",
  borderColor = "border-gray-200",
  textColor = "text-gray-800",
  status='',
  priority=''
}) {
  const navigate=useNavigate();
  return (
    <div
      to={to}
      onClick={()=>{to && navigate(`${to}`,{state:{status,priority}})}}
      className="group w-full transition-transform transform hover:scale-95 active:scale-100 duration-200 "
    >
      <div
      style={{boxShadow: `rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px`}}
        className={`h-[16vh] sm:h-[18vh] md:h-[22vh] xl:h-[25vh]
rounded-xl md:rounded-2xl
p-2 sm:p-3 md:p-4
flex flex-col justify-center items-center space-y-2 md:space-y-3
${bgColor} ${borderColor} ${textColor}`}

      >
        <div className="flex items-center justify-center w-10 h-10 md:w-14 md:h-14">
  <Icon className="text-xl md:text-2xl xl:text-3xl" />
</div>


        <div className="text-center">
  <p className="text-sm md:text-base 2xl:text-lg font-semibold">
    {label}
  </p>

  <p className="text-xl md:text-2xl xl:text-3xl font-bold mt-0.5 md:mt-1">
    {count}
  </p>
</div>

      </div>
    </div>
  );
}

